export enum ButtonClass {
    Contained = "cui-button--contained",
    Outlined = "cui-button--outlined"
}
